function e(){return n}var n=t=>t;export{e as a};
